import React from 'react';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { cn } from './_cn';
import TWPagination from './tw-pagination';

const TWDataTable = ({
  columns,
  data,
  loading,
  rowKey = 'id',
  rowClickPath,
  onRowClick,
  pagination,
  empty,
  size = 'small',
  className = '',
  tableClassName = '',
  scroll,
  ...rest
}) => {
  const navigate = useNavigate();

  const buildOnRow = (record) => {
    if (rowClickPath) {
      const path =
        typeof rowClickPath === 'function' ? rowClickPath(record) : rowClickPath;
      // A function form can opt a specific row out of navigation (e.g. a
      // row with no real detail page to land on) by returning a falsy
      // value instead of a path — that row gets no onClick and no
      // clickable-row styling.
      if (!path) return {};
      return {
        onClick: () => navigate(path),
        className:
          'cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/60',
      };
    }
    if (onRowClick) {
      return {
        onClick: () => onRowClick(record),
        className:
          'cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/60',
      };
    }
    return {};
  };

  const paginationEnabled = pagination && (pagination.total ?? 0) > 0;

  return (
    <div className={cn('tw-table-wrapper w-full', className)}>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={rowKey}
        loading={loading}
        pagination={false}
        size={size}
        onRow={buildOnRow}
        locale={empty ? { emptyText: empty } : undefined}
        className={tableClassName}
        scroll={scroll || { x: 'max-content' }}
        {...rest}
      />
      {paginationEnabled ? (
        <div className="border-t border-slate-200 bg-slate-50/60 px-4 py-3 dark:border-slate-700 dark:bg-slate-800/60">
          <TWPagination {...pagination} align="between" />
        </div>
      ) : null}
    </div>
  );
};

export default TWDataTable;
